module.exports = __webpack_public_path__ + "static/bonjour-282fd5683cd23cc5020f425b37154879.png";